import { Directive, TemplateRef } from "@angular/core";

@Directive({
    selector: "[appExpansionPanelContent]",
    standalone: false
})
export class ExpansionPanelContentDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
